var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRequestQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#82888D",
  d: "M9.167 15.833h1.666V15h.834q.354 0 .594-.24t.239-.593v-2.5a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24h-2.5V10H12.5V8.333h-1.667V7.5H9.167v.833h-.834a.8.8 0 0 0-.593.24.8.8 0 0 0-.24.594v2.5q0 .354.24.593.24.24.593.24h2.5v.833H7.5V15h1.667zM5 18.333q-.687 0-1.177-.489a1.6 1.6 0 0 1-.49-1.177V3.333q0-.687.49-1.177T5 1.666h6.667l5 5v10q0 .688-.49 1.178t-1.177.49zm5.833-11.666V3.333H5v13.334h10v-10z"
})));
export { SvgRequestQuote as ReactComponent };
export default __webpack_public_path__ + "static/media/request_quote.5567af93.svg";